<!--
 * @Description: 产品报告
 * @Autor: wangwangwang
 * @Date: 2021-03-22 18:37:24
 * @LastEditors: hexy
 * @LastEditTime: 2025-04-02 10:18:35
-->
<template>
  <div>
    <!-- 产品报告 -->
    <el-dialog :visible.sync="look1Type" width="880px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">产品报告</span>
      <div class="dialogOtherinfo">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="table2" tooltip-effect="dark">
          <el-table-column prop="productName" label="产品名" align="center"></el-table-column>
          <el-table-column label="自检报告" width="auto" align="center">
            <template slot-scope="scope">
              <span class="table_link" @click="look11Fun(scope.row, '出场')">出场检验编号</span>
            </template>
          </el-table-column>
          <el-table-column label="抗渗报告" width="auto" align="center">
            <template slot-scope="scope">
              <span class="table_link" @click="look11Fun(scope.row, '抗渗报告')">抗渗报告</span>
            </template>
          </el-table-column>
          <el-table-column label="第三方报告" width="auto" align="center">
            <template slot-scope="scope">
              <span class="table_link" @click="look11Fun(scope.row, '第三方')">第三方检验</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="look1Type = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 配合比 -->
    <el-dialog :visible.sync="look2Type" width="1200px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">配合比</span>
      <div class="dialogOtherinfo">
        <el-form ref="reffromDate" :inline="true" :model="fromDate" label-width="135px">
          <div>
            <el-form-item v-if="pageType != 2" label="产品名称">
              <span>{{ fromDate.productName }}</span>
            </el-form-item>
            <el-form-item v-if="pageType != 2" label="开盘浇筑部位">
              <span>{{ fromDate.structuralParts }}</span>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="水泥原物料品牌" prop="cementBrandId" :rules="[{ required: true, message: '请选择水泥原物料品牌', trigger: 'blur' }]">
              <el-select v-model="fromDate.cementBrandId" placeholder="请选择" style="width: 220px" filterable>
                <el-option v-for="(item, index) in arr3_3" :key="index" :label="item.itemName" :value="item.id" @click.native="fromDate.cementBrandName = item.itemName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="pageType != 2" label="开盘工程名称" prop="openingProjecName" :rules="[{ required: true, message: '请输入开盘工程名称', trigger: 'blur' }]">
              <el-select v-model="fromDate.openingProjecName" style="width: 220px" placeholder="请选择" filterable allow-create default-first-option>
                <el-option v-for="(item, index) in openingProjecList" :key="index" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <el-form-item label="配合比类型">
            <el-select v-model="fromDate.type" style="width: 220px" placeholder="请选择" @change="workMixRatioqueryListByGeneralFun()">
              <el-option label="通用配合比" :value="1"></el-option>
              <el-option label="专用配合比" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="配合比年份">
            <el-date-picker v-model="fromDate.date" type="year" value-format="yyyy" placeholder="选择日期" @change="workMixRatioqueryListByGeneralFun()"> </el-date-picker>
          </el-form-item>
          <el-form-item label="配合比名称">
            <el-select v-model="fromDate.DetailId" style="width: 220px" placeholder="请选择" filterable @change="workMixRatiogetRatioDetailFun()">
              <el-option v-for="(item, index) in arr3_5" :key="index" :label="fromDate.type == 1 ? item.name : item.name + '_' + item.engineeringName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="报告日期" prop="resportTime" :rules="[{ required: true, message: '请选择报告日期', trigger: 'change' }]">
            <el-date-picker v-model="fromDate.resportTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"> </el-date-picker>
          </el-form-item>
          <el-form-item label="施工单位">
            <el-input v-model="fromDate.roadwork" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <div>
            <el-form-item prop="enginnerrMixRatio" label-width="190px" :rules="[{ required: true, message: '请输入工程配合比特殊要求', trigger: 'blur' }]">
              <span slot="label" style="font-size: 18px">工程配合比特殊要求</span>
              <el-input v-model="fromDate.enginnerrMixRatio" style="width: 520px" placeholder="请输入" clearable size="medium"></el-input>
            </el-form-item>
          </div>

          <div class="form-title" style="margin-bottom: 10px">搜索历史配合比</div>
          <el-form-item label="工程名称">
            <el-select v-model="tableParam3.engineeringId" style="width: 180px" filterable placeholder="请选择">
              <el-option v-for="(item, index) in engineeringIdList" :key="index" :label="item.engineeringName" :value="item.engineeringId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="浇筑部位">
            <el-input v-model="tableParam3.structuralParts" style="width: 180px" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item label="产品名">
            <el-input v-model="tableParam3.productName" style="width: 180px" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-button icon="el-icon-search" size="medium" class="bottom_all" @click="(tableParam3.page = 1), gettableData()">查 询</el-button>
          <el-table
            ref="singleTable"
            :header-cell-style="{ background: '#f3f6f9' }"
            :cell-style="{ borderRight: 'none' }"
            border
            stripe
            style="width: 100%"
            :data="table3"
            tooltip-effect="dark"
            highlight-current-row
            @current-change="currentChange3"
          >
            <el-table-column type="selection" width="55">
              <template slot-scope="scope">
                <el-radio v-model="yiFenPeiRadio" :label="scope.row.id">{{ "" }}</el-radio>
              </template>
            </el-table-column>
            <el-table-column prop="orderNo" label="订单编号" width="auto" align="center"></el-table-column>
            <el-table-column prop="engineeringName" label="工程名称" width="120" align="center"></el-table-column>
            <el-table-column prop="place" label="工程地址" width="auto" align="center"></el-table-column>
            <el-table-column prop="structuralParts" label="浇筑部位" width="120" align="center"></el-table-column>
            <el-table-column prop="productName" label="产品名" width="auto" align="center"></el-table-column>
            <el-table-column prop="mixRatioNumber" label="交工配合比编号" width="120" align="center"></el-table-column>
            <el-table-column prop="reportTime" label="报告时间" width="auto" align="center"></el-table-column>
            <el-table-column prop="pouringTime" label="浇筑时间" width="auto" align="center"></el-table-column>
          </el-table>
          <el-pagination :current-page.sync="tableParam3.page" :page-size="tableParam3.pageSize" layout="total, prev, pager, next, jumper" :total="tableParam3.total" @current-change="gettableData()"></el-pagination>
          <div class="form-title" style="margin-bottom: 10px">配合比参数</div>
          <el-form-item prop="unitWeight" :rules="[{ required: true, message: '请输入容重', trigger: 'blur' }]">
            <span slot="label" style="color: #ff0000">容重kg/m³</span>
            <el-input v-model="fromDate.unitWeight" type="Number" placeholder="请输入" clearable @change="calculatorFun(true)"></el-input>
          </el-form-item>
          <el-form-item prop="totalPlasticMaterial" :rules="[{ required: true, message: '请输入胶材总量', trigger: 'blur' }]">
            <span slot="label" style="color: #ff0000">胶材总量</span>
            <el-input v-model="fromDate.totalPlasticMaterial" type="Number" placeholder="请输入" clearable @change="calculatorFun(true)"></el-input>
          </el-form-item>
          <el-form-item prop="waterBinderRatio" :rules="[{ required: true, message: '请输入水胶比', trigger: 'blur' }]">
            <span slot="label" style="color: #ff0000">水胶比</span>
            <el-input v-model="fromDate.waterBinderRatio" type="Number" placeholder="请输入" clearable @change="calculatorFun(true)"></el-input>
          </el-form-item>
          <el-form-item prop="sandRatio" :rules="[{ required: true, message: '请输入砂率', trigger: 'blur' }]">
            <span slot="label" style="color: #ff0000">砂率%</span>
            <el-input v-model="fromDate.sandRatio" type="Number" placeholder="请输入" clearable @change="calculatorFun(true)"></el-input>
          </el-form-item>
          <el-form-item prop="slump" :rules="[{ required: true, message: '请输入坍落度', trigger: 'blur' }]">
            <span slot="label" style="color: #ff0000">坍落度(mm)</span>
            <el-input v-model="fromDate.slump" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item prop="temperature" :rules="[{ required: true, message: '请输入选用温度', trigger: 'blur' }]">
            <span slot="label" style="color: #ff0000">选用温度(℃)</span>
            <!-- <el-input v-model="fromDate.temperature" placeholder="请输入" clearable></el-input> -->
            <el-select v-model="fromDate.temperature" placeholder="请选择">
              <el-option key="5 ~ 35" label="5 ~ 35" value="5 ~ 35"></el-option>
              <el-option key="0 ~ 25" label="0 ~ 25" value="0 ~ 25"></el-option>
              <el-option key="20 ~ 35" label="20 ~ 35" value="20 ~ 35"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="consistency">
            <span slot="label" style="color: #ff0000">稠度</span>
            <el-input v-model="fromDate.consistency" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item prop="settingTime">
            <span slot="label" style="color: #ff0000">凝结时间</span>
            <el-input v-model="fromDate.settingTime" type="Number" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item prop="calculateRatioMethod" :rules="[{ required: true, message: '请选择配合比值来源', trigger: 'change' }]">
            <span slot="label" style="color: #ff0000">配合比值来源</span>
            <!-- <el-input v-model="fromDate.temperature" placeholder="请输入" clearable></el-input> -->
            <el-radio-group v-model="fromDate.calculateRatioMethod" style="width: 215px" @change="calculatorFun(true)">
              <el-radio :label="0">自动计算</el-radio>
              <el-radio :label="1">手动输入</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item prop="conveyWay" :rules="[{ required: true, message: '请选择输送方式', trigger: 'change' }]">
            <span slot="label" style="color: #ff0000">输送方式</span>
            <el-radio-group v-model="fromDate.conveyWay" style="width: 215px">
              <el-radio :label="1">泵送</el-radio>
              <el-radio :label="2">非泵送</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- <el-form-item v-if="mixRatioNumberType">
            <span slot="label" style="color: #ff0000">配合比编号</span>
            <el-input v-model="fromDate.mixRatioNumber" type="Number" placeholder="请输入" clearable></el-input>
          </el-form-item> -->
          <el-form-item prop="concreteRatioNumber" :rules="[{ required: true, message: '请输入混凝土配合比编号', trigger: 'blur' }]">
            <span slot="label" style="color: #ff0000">混凝土配合比编号</span>
            <el-input v-model="fromDate.concreteRatioNumber" type="Number" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <div style="padding-bottom: 10px">
            <el-button size="mini" class="bottom_all" style="margin-left: 0" @click="addItem()">
              <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
              添加
            </el-button>
            <el-button size="mini" class="bottom_two" style="margin-left: 10px" @click="deleAllItem()"> 清空</el-button>
          </div>
          <el-table  v-loading="toViewListLoad"  :header-cell-style="{ background: '#f3f6f9' }"  :cell-style="{ borderRight: 'none' }"  border  :row-class-name="tableRowClassName"  style="width: 100%"  :data="toViewList"  tooltip-effect="dark"  class="FZYtable">
            <el-table-column label="原物料" align="center" prop="orderNo" width="140">
              <template slot-scope="scope">
                <el-select v-model="scope.row.rawId" placeholder="请选择" style="width: 100%" filterable @change="changeItem(scope.row, 'rawId')">
                  <el-option v-for="(item, index) in rawIdArry" :key="index" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="规格型号" align="center" prop="orderNo" width="140">
              <template slot-scope="scope">
                <el-select v-model="scope.row.specificationId" placeholder="请选择" style="width: 100%" filterable clearable @change="changeItem(scope.row, 'specificationId')">
                  <el-option v-for="(item, index) in specificationIdArry" :key="index" :label="item.itemName" :value="item.id"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="公式参数类型" align="center" prop="orderNo" width="140">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.formulaParametersId"
                  placeholder="请选择"
                  style="width: 100%"
                  :disabled="$options.filters.filtFormula(scope.$index)"
                  @change="changeItem(scope.row, 'formulaParametersId', scope.$index)"
                >
                  <el-option v-for="(item, index) in formulaParametersIdArry" :key="index" :label="item.name" :value="item.id" :disabled="item.type"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="参数类型" align="center" prop="parametersType" width="100"></el-table-column>
            <el-table-column label="参量" align="center" width="150">
              <template slot-scope="scope">
                <div v-if="scope.$index > 2" style="text-align: left">
                  <el-input-number
                    v-model="scope.row.parameter"
                    :controls="false"
                    :precision="$options.filters.precision(scope.row)"
                    style="width: 80px"
                    :disabled="scope.row.formulaParametersId == 2"
                    @change="calculatorFun()"
                  ></el-input-number>
                  <span v-if="scope.row.formulaParametersId != 6"> %</span><span v-else> kg/m³</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="配合比值" align="center" width="180">
              <template slot-scope="scope">
                <el-input v-if="fromDate.calculateRatioMethod == 1" v-model="scope.row.ratioValue" style="width: 170px" type="Number" placeholder="请输入">
                  <template slot="append">kg/m³</template>
                </el-input>
                <span v-else> {{ scope.row.ratioValue }} kg/m³ </span>
              </template>
            </el-table-column>
            <el-table-column label="自检报告" align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.formulaParametersId != 1 && scope.row.ratioValue != 0">
                  <span v-if="scope.row.selfBarchNum" class="table_link" @click="look21Fun(scope.row, '批次检验', scope.$index)">{{ scope.row.selfBarchNum }}</span>
                  <span v-else class="table_link" @click="look21Fun(scope.row, '批次检验', scope.$index)">选择</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="原物料品牌" align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.formulaParametersId != 1 && scope.row.ratioValue != 0">
                  <span v-if="scope.row.brand">{{ scope.row.brand }}</span>
                  <span v-else></span>
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column label="厂家材质报告" align="center">
              <template v-if="scope.row.formulaParametersId !=1" slot-scope="scope">
                <el-upload action="/resource/resources/upload" :show-file-list="false" :before-upload="beforeUpload" :on-success="filesuccess" :headers="upheader">
                  <el-link class="table_link" :underline="false" @click="scopeIndex=1,rowIndex=scope.$index">{{scope.row.materialReportPath?'修改':'上传'}}</el-link>
                </el-upload>
                <div v-if="scope.row.materialReportPath" class="upload-item-text">
                  <a class="el-link" :href="'/file/' +scope.row.materialReportPath" download>
                    <span style="color:#3f8e4d;">{{scope.row.materialReport}}</span>
                    <i class="el-icon-download" style="padding:0 10px"></i>
                  </a>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="合格证" align="center">
              <template v-if="scope.row.formulaParametersId !=1" slot-scope="scope">
                <el-upload action="/resource/resources/upload" :show-file-list="false" :before-upload="beforeUpload" :on-success="filesuccess" :headers="upheader">
                  <el-link class="table_link" :underline="false" @click="scopeIndex=2,rowIndex=scope.$index">{{scope.row.qualificationPath?'修改':'上传'}}</el-link>
                </el-upload>
                <div v-if="scope.row.qualificationPath" class="upload-item-text">
                  <a class="el-link" :href="'/file/' +scope.row.qualificationPath" download>
                    <span style="color:#3f8e4d;">{{scope.row.materialReport}}</span>
                    <i class="el-icon-download" style="padding:0 10px"></i>
                  </a>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="第三方报告" align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.ratioValue!=0">
                  <span v-if="scope.row.selfRipartiteNum" class="table_link" @click="look21Fun(scope.row,'第三方检验',scope.$index)">{{scope.row.selfRipartiteNum}}</span>
                  <span v-else class="table_link" @click="look21Fun(scope.row,'第三方检验',scope.$index)">选择</span>
                </div>
              </template>
            </el-table-column> -->
            <el-table-column label="操作" align="left" width="100">
              <template slot-scope="scope">
                <el-button v-show="$options.filters.filtDel(scope.$index)" size="mini" class="bottom_two" @click="deleteItem(scope.$index)">
                  <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="look2Type = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="discloseupdateOneFun()">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 产品名-自检报告 -->
    <el-dialog :visible.sync="look11Type" width="880px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">自检报告</span>
      <div class="dialogOtherinfo">
        <p>
          <span v-if="name == '出场'">抗压报告</span>
          <span v-if="name == '抗渗报告'">抗渗报告</span>
          <span v-if="name == '第三方'">第三方报告</span>
          <el-button v-if="name != '第三方'" size="mini" class="bottom_all" style="float: right; position: relative; top: -5px" @click="selfreportsaveOneFun()">
            <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
            新增报告
          </el-button>
        </p>
        <el-table
          ref="table11Refs"
          height="300"
          :header-cell-style="{ background: '#f3f6f9' }"
          :cell-style="{ borderRight: 'none' }"
          border
          stripe
          style="width: 100%"
          :data="table11"
          tooltip-effect="dark"
          highlight-current-row
          @selection-change="selectionChange11"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column prop="checkoutNumber" label="出场检验编号" width="auto" align="center"></el-table-column>
          <el-table-column prop="productName" label="产品名" width="260" align="center"></el-table-column>
          <el-table-column prop="engineeringName" label="工程名称" width="auto" align="center"></el-table-column>
          <el-table-column v-if="name != '第三方'" prop="" label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-link class="table_link" :underline="false" @click="modifyLookFun(scope.row)">修改</el-link>
              <el-link v-if="scope.row.checkStatus != 1 && name == '第三方'" class="table_link" :underline="false" style="color: red" @click="delTable11Fun(scope.row)">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="look11Type = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="planSelfsaveManyFun()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 配合比-自检报告 -->
    <el-dialog :visible.sync="look21Type" width="880px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">自检报告</span>
      <div class="dialogOtherinfo">
        <p style="display: flex; align-items: center; justify-content: space-between">
          <span v-if="name2 == '批次检验'">选择自检报告库（4天后自动过期）</span><span v-else>选择第三方报告库（3天后自动过期）</span>
          <span>
            <span>自检报告编号 <el-input v-model="tableParam21.checkoutNumber" clearable style="width: 100px" @change="getmaintenancelist21()"></el-input></span>
            <el-button class="bottom_all" style="margin-left: 24px" @click="customizedReport()">自定义报告</el-button>
            <el-button class="bottom_all" style="margin-left: 24px" @click="openBatchcheckout()">批次检验</el-button>
          </span>
        </p>
        <el-table
          :header-cell-style="{ background: '#f3f6f9' }"
          :cell-style="{ borderRight: 'none' }"
          border
          stripe
          style="width: 100%"
          :data="table21"
          tooltip-effect="dark"
          highlight-current-row
          @current-change="selectionChange21radioFun"
        >
          <el-table-column width="55">
            <template slot-scope="scope">
              <el-radio v-model="selectionChange21radio" :label="scope.row.id">{{ "" }}</el-radio>
            </template>
          </el-table-column>
          <el-table-column prop="checkoutNumber" :label="name2 == '批次检验' ? '自检报告编号' : '三方报告编号'" width="auto" align="center"></el-table-column>
          <el-table-column prop="rawName" label="原物料名称" width="auto" align="center"></el-table-column>
          <el-table-column v-if="name2 == '批次检验'" prop="brand" label="品牌" width="auto" align="center"></el-table-column>
          <el-table-column v-if="name2 == '批次检验'" prop="specification" label="规格" width="auto" align="center"></el-table-column>
          <el-table-column v-if="name2 == '批次检验'" prop="originPlace" label="产地" width="auto" align="center"></el-table-column>
          <el-table-column v-if="name2 == '批次检验'" prop="manufacturer" label="厂家" width="auto" align="center"></el-table-column>
          <el-table-column prop="supplierName" label="供应商" width="auto" align="center"></el-table-column>
          <el-table-column prop="dataOfProduction" label="水泥出厂日期" width="auto" align="center"></el-table-column>
          <el-table-column prop="factoryNumber" label="水泥出厂编号" width="auto" align="center"></el-table-column>
          <el-table-column v-if="name2 == '批次检验'" prop="" label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-link class="table_link" :underline="false" @click="modifyLookFun(scope.row, false)">修改</el-link>
              <el-link v-if="scope.row.checkStatus != 1" class="table_link" :underline="false" style="color: red" @click="delTable21Fun(scope.row)">过期</el-link>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination :current-page.sync="tableParam21.page" :page-size="tableParam21.pageSize" layout="total, prev, pager, next, jumper" :total="tableParam21.total" @current-change="getmaintenancelist21()"></el-pagination>
        <!-- <p><span v-if="name2 == '批次检验'">批次检验列表</span><span v-else>第三方原物料检验列表</span></p>
        <el-table ref="singleTable" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="table22" tooltip-effect="dark" highlight-current-row>
          <el-table-column prop="checkoutNumber" :label="name2 == '批次检验' ? '批次检验编号' : '三方报告编号'" width="auto" align="center">
            <template slot-scope="scope">
              <span v-if="name2 == '批次检验'">{{ scope.row.checkoutNumber }}</span>
              <span v-else>{{ scope.row.code }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="rawName" label="原物料名称" width="auto" align="center"></el-table-column>
          <el-table-column v-if="name2 == '批次检验'" prop="brand" label="品牌" width="auto" align="center"></el-table-column>
          <el-table-column v-if="name2 == '批次检验'" prop="specification" label="规格" width="auto" align="center"></el-table-column>
          <el-table-column v-if="name2 == '批次检验'" prop="originPlace" label="产地" width="auto" align="center"></el-table-column>
          <el-table-column prop="supplierName" label="供应商" width="auto" align="center"></el-table-column>
          <el-table-column prop="" label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-link class="table_link" :underline="false" @click="modifyLookFun(scope.row, true)">查看</el-link>
              <el-link :disabled="scope.row.additionStatus != 1" class="table_link" :underline="false" @click="addtable21(scope.row, '原物料')">添加到库</el-link>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination :current-page.sync="tableParam22.page" :page-size="tableParam22.pageSize" layout="total, prev, pager, next, jumper" :total="tableParam22.total" @current-change="getmaintenancelist22()"></el-pagination> -->
        <p style="display: flex; align-items: center; justify-content: space-between">
          <span v-if="name2 == '批次检验'">已过期自检报告库</span><span v-else>第三方已过期自检报告库</span>
          <span>
            <span>
              <span
                >检测天数 <el-input v-model="tableParam23.checkStartDay" style="width: 80px" clearable placeholder="请输入" @change="getmaintenancelist23()" />至<el-input
                  v-model="tableParam23.checkEndDay"
                  style="width: 80px"
                  clearable
                  placeholder="请输入"
                  @change="getmaintenancelist23()"
              /></span>
            </span>
            <span>
              <span>自检报告编号 <el-input v-model="tableParam23.checkoutNumber" clearable style="width: 100px" @change="getmaintenancelist23()"></el-input></span>
            </span>
          </span>
        </p>
        <el-table ref="singleTable" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="table23" tooltip-effect="dark" highlight-current-row>
          <el-table-column width="55">
            <template slot-scope="scope">
              <el-radio v-model="selectionChange21radio" :label="scope.row.id">{{ "" }}</el-radio>
            </template>
          </el-table-column>
          <el-table-column prop="checkoutNumber" :label="name2 == '批次检验' ? '自检报告编号' : '三方报告编号'" width="auto" align="center"></el-table-column>
          <el-table-column prop="rawName" label="原物料名称" width="auto" align="center"></el-table-column>
          <el-table-column v-if="name2 == '批次检验'" prop="brand" label="品牌" width="auto" align="center"></el-table-column>
          <el-table-column v-if="name2 == '批次检验'" prop="specification" label="规格" width="auto" align="center"></el-table-column>
          <el-table-column v-if="name2 == '批次检验'" prop="originPlace" label="产地" width="auto" align="center"></el-table-column>
          <el-table-column v-if="name2 == '批次检验'" prop="manufacturer" label="厂家" width="auto" align="center"></el-table-column>
          <el-table-column prop="supplierName" label="供应商" width="auto" align="center"></el-table-column>
          <el-table-column prop="dataOfProduction" label="水泥出厂日期" width="auto" align="center"></el-table-column>
          <el-table-column prop="factoryNumber" label="水泥出厂编号" width="auto" align="center"></el-table-column>
          <el-table-column prop="" label="操作" width="120" align="center">
            <template slot-scope="scope">
              <!-- <el-link class="table_link" :underline="false" @click="modifyLookFun(scope.row, true)">查看</el-link> -->
              <el-link class="table_link" :underline="false" @click="modifyLookFun(scope.row, false)">修改</el-link>
              <el-link class="table_link" :underline="false" @click="addtable21(scope.row, '已过期')">复制到库</el-link>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination :current-page.sync="tableParam23.page" :page-size="tableParam23.pageSize" layout="total, prev, pager, next, jumper" :total="tableParam23.total" @current-change="getmaintenancelist23()"></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="look21Type = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="addListlist0Fun()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 产品名+配合比-自检报告-修改 -->
    <el-dialog :visible.sync="look11ModifyType" width="880px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">修改</span>
      <div class="dialogOtherinfo">
        <div v-if="nameName == '产品名'" style="padding: 0px 0px 10px 10px">
          <div style="display: inline-block; margin-right: 50px">
            自检报告编号：
            <el-input v-model="data11Info.checkoutNumber" :disabled="modifyType" tplaceholder="请输入" clearable style="width: 215px; margin-left: 25px"></el-input>
          </div>
          <div style="display: inline-block; margin-right: 50px">产品名：{{ data11Info.productName }}</div>
          <div>工程名：{{ data11Info.engineeringName }}</div>
        </div>
        <!-- <div v-else-if="nameName == '配合比'">
          <div style="display: inline-block; margin-right: 50px">
            自检报告编号：<el-input v-model="data11Info.checkoutNumber" :disabled="modifyType" tplaceholder="请输入" clearable style="width: 215px; margin-left: 25px"></el-input>
          </div>
          <div style="display: inline-block; margin-right: 50px">原物料名称：{{ data11Info.rawName }}</div>
          <div style="padding: 5px">
            供应商：
            <el-input v-model="data11Info.supplierName" :disabled="modifyType" style="width: 215px; margin-left: 25px" placeholder="请输入"></el-input>
          </div>
        </div> -->
        <el-form v-if="name == '出场'" label-width="110px">
          <el-form-item label="构件尺寸：">
            <el-select v-model="data11Info.sizeValue" style="width: 215px; margin-left: 25px" :disabled="modifyType" placeholder="请选择">
              <el-option label="100mm*100mm*100mm" value="100mm*100mm*100mm"></el-option>
              <el-option label="150mm*150mm*150mm" value="150mm*150mm*150mm"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-form label-width="110px" :disabled="modifyType" :inline="true">
          <div v-if="nameName == '配合比'">
            <el-form-item label="自检报告编号" prop="startTime">
              <el-input v-model="data11Info.checkoutNumber" :disabled="modifyType" tplaceholder="请输入" clearable style="width: 215px; margin-left: 25px"></el-input>
            </el-form-item>
            <el-form-item label="原物料名称">
              <span style="width: 215px; margin-left: 25px">{{ data11Info.rawName }}</span>
            </el-form-item>
            <el-form-item label="供应商" prop="startTime">
              <el-input v-model="data11Info.supplierName" :disabled="modifyType" style="width: 215px; margin-left: 25px" placeholder="请输入"></el-input>
            </el-form-item>
          </div>
          <el-form-item label="试验日期" prop="startTime">
            <el-date-picker v-model="data11Info.samplingDate" style="width: 215px; margin-left: 25px" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"></el-date-picker>
          </el-form-item>
          <el-form-item label="检测人" prop="startTime" class="FZYplaceholder">
            <!-- <el-input v-model="data11Info.inspector" style="width:215px;margin-left:25px;" placeholder="请输入"></el-input> -->
            <!-- <TreeSelect
              ref="inspectorName"
              :value="data11Info.inspectorId0"
              :loadData="onLoadData"
              :placeholder="inspectorName"
              style="width: 200px; height: 36px; z-index: 100000"
              :tree-data="treeData"
              allowClear
              multiple
              :replaceFields="{ title: 'name', value: 'id' }"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              @change="selectInspector"
            ></TreeSelect> -->
            <!-- <el-cascader ref="inspector" v-model="data11Info.inspectorId0" style="width: 227px"
                :options="treeData" :show-all-levels="false" :props="{ value: 'id', label: 'name', multiple:true,emitPath:false }"
                :placeholder="inspectorName" filterable @change="selectInspector">
            </el-cascader> -->
            <el-select ref="inspectorId" v-model="data11Info.inspectorId0" multiple placeholder="请选择" value-key="id" style="width: 215px; margin-left: 25px" filterable @change="selectInspector">
              <el-option v-for="item in userList" :key="item.id" :label="item.name + '_' + item.company" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产地">
            <el-input v-model="data11Info.originPlace" tplaceholder="请输入" clearable style="width: 215px; margin-left: 25px"></el-input>
          </el-form-item>
          <el-form-item label="生产厂家">
            <el-input v-model="data11Info.manufacturer" tplaceholder="请输入" clearable style="width: 215px; margin-left: 25px"></el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label">水泥出厂日期</span>
            <el-date-picker v-model="data11Info.dataOfProduction" type="date" value-format="yyyy-MM-dd" style="width: 215px; margin-left: 25px" placeholder="选择日期"> </el-date-picker>
          </el-form-item>
          <el-form-item>
            <span slot="label">水泥出厂编号</span>
            <el-input v-model="data11Info.factoryNumber" style="width: 215px; margin-left: 25px" clearable placeholder="请输入" />
          </el-form-item>
        </el-form>
        <br />
        <el-table ref="singleTable" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="table11Modify" tooltip-effect="dark" highlight-current-row>
          <el-table-column prop="acceptanceItems" label="验收项目" width="auto" align="center"></el-table-column>
          <!-- <el-table-column prop="technicalRequirements" label="技术要求" width="260" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.resultValueType == 3">
                {{scope.row.technicalRequirements+'：'+(scope.row.section?scope.row.section:'')}}
              </div>
              <div v-else>
                {{scope.row.section?scope.row.section:''}}
              </div>
            </template>
          </el-table-column> -->
          <el-table-column prop="lowerLimitVlue" label="下限值" width="auto" align="center"></el-table-column>
          <el-table-column prop="upperLimitVlue" label="上限值" width="auto" align="center"></el-table-column>
          <el-table-column label="结果值" width="auto" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.resultValueType == 3">
                <el-input v-model="scope.row.resultValue" :disabled="modifyType" style="width: 100%" @input="checkOkNgFun(scope.row.resultValue, scope.row.technicalRequirements, scope.row.section, scope.row)"></el-input>
              </div>
              <div v-else>
                {{ scope.row.resultValue }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="resultJudge" label="结果判断" width="auto" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.resultJudge == 'OK'" style="color: #4d906f">OK</span>
              <span v-if="scope.row.resultJudge == 'NG'" style="color: red">NG</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="look11ModifyType = false">取 消</el-button>
        <el-button v-if="!modifyType" class="bottom_all" style="margin-left: 24px" @click="selfdetectionupdateManyFun()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 批次检验列表单选 -->
    <el-dialog :visible.sync="checkoutDig" width="70%" :append-to-body="true" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">选择</span>
      <div class="dialogOtherinfo fzyDivFlex">
        <div>
          <el-form ref="form" inline :model="checkoutTableParam" label-width="100px">
            <el-form-item label="检测时间">
              <el-date-picker v-model="checkoutTableParam.time" type="daterange" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"> </el-date-picker>
            </el-form-item>
            <el-form-item label="物料">
              <el-select v-model="checkoutTableParam.rawNameId" clearable style="width: 100px" placeholder="请选择">
                <el-option v-for="(item, index) in rawIdArry" :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="站点">
              <el-select v-model="checkoutTableParam.stationId" filterable clearable style="width: 100px" placeholder="请选择">
                <el-option v-for="(item, index) in stationList" :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="规格">
              <el-select v-model="checkoutTableParam.specificationId" filterable clearable style="width: 100px" placeholder="请选择">
                <el-option v-for="(item, index) in specificationIdArry" :key="index" :label="item.itemName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="品牌">
              <el-select v-model="checkoutTableParam.brand" filterable clearable style="width: 100px" placeholder="请选择">
                <el-option v-for="(item, index) in arr3_3" :key="index" :label="item.itemName" :value="item.itemName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="供应商名称">
              <el-input v-model="checkoutTableParam.supplierName" tplaceholder="请输入" clearable style="width: 400px"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" size="medium" class="bottom_all" @click="searchCheckout()">查 询</el-button>
            </el-form-item>
          </el-form>
          <el-table
            :header-cell-style="{ background: '#f3f6f9' }"
            :cell-style="{ borderRight: 'none' }"
            border
            stripe
            style="width: 100%"
            height="500"
            :data="checkoutData"
            tooltip-effect="dark"
            highlight-current-row
            @row-click="ListChoiceFun"
          >
            <el-table-column width="50" fixed>
              <template slot-scope="scope">
                <el-radio v-model="ListChoiceRadio" :disabled="scope.row.disabled" :label="scope.row.id">{{ "" }}</el-radio>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="生成时间" width="165"> </el-table-column>
            <el-table-column prop="supplier" width="200" label="供应商名称"> </el-table-column>
            <el-table-column prop="rawName" label="物料名称"> </el-table-column>
            <el-table-column prop="specification" label="规格" width="100"> </el-table-column>
            <el-table-column prop="brand" label="品牌" width="100"> </el-table-column>
            <el-table-column prop="detectionTime" label="检验时间" width="165"> </el-table-column>
            <el-table-column prop="code" label="检验编号" width="160"> </el-table-column>
            <el-table-column prop="station" label="站点" width="150"> </el-table-column>
          </el-table>
          <div class="card_bottom">
            <div class="card_bottom_left">
              <div class="top_page_totle">总共{{ checkoutTableParam.total }}条</div>
              <el-pagination
                :current-page.sync="checkoutTableParam.page"
                :page-size="checkoutTableParam.pageSize"
                layout="prev, pager, next, jumper"
                :total="checkoutTableParam.total"
                @current-change="searchCheckout()"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="checkoutDig = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="ListChoiceAddFun()">确 定</el-button>
      </span>
    </el-dialog>
    <customizedReport :visible.sync="reportDig" :rawName="list0Row.rawName" @confirm="confirmCustomizedReport()"></customizedReport>
  </div>
</template>

<script>
import {
  saveOneProduct,
  selfreportqueryPage,
  selfreportqueryChecked,
  selfreportdelectMany,
  selfdetectionqueryByReportId,
  selfdetectionupdateMany,
  planSelfsaveMany,
  //以上是产品的接口
  disclosequeryOne,
  discloseupdateOne,
  workMixRatioqueryListByGeneral,
  workMixRatiogetRatioDetail,
  dataMixqueryPlan,
  dataMixgetRatioDetail,
  dataMixsaveOrUpdate,
  dataMixgetByPlan,
  clearPlanReport,
  queryEngineeringList,
  //以上是配合比的接口
  makequeryByRaw,
  rawgetPageByRaw,
  saveOneRaw,
  saveResport,
  saveNewByCopy,
  checkoutQuerypage,
  queryPlanEngineeringName,
  expireReport,
  queryPageRaw,
  getNewDetaHistory,
} from "@/api/smart/produceCoordinate.js";
import { getDicType, getFileDetails, getOrgznizationAndUsersTree, orgUserTree, getUserAutList } from "@/api/common.js";
import { Loading } from "element-ui";
import { getToken, getUserId } from "@/utils/auth";
import { getUserInfoList } from "@/api/basedata/user.js";
import moment from "moment";
//import { getUserInfo } from "@/utils/auth.js";
let loadingInstance;
//import { TreeSelect } from "ant-design-vue";
export default {
  components: { customizedReport: () => import("./customizedReport.vue") },
  //pageType 为2是交工资料-配合比
  props: ["status", "pageType"],
  data() {
    return {
      userList: [],
      inspectorName: "",
      treeData: [],
      upheader: {
        "access-token": getToken(),
        "user-id": getUserId(),
      },
      scopeIndex: "", //1厂家材质报告，2合格证书
      rowIndex: "", //第几行的
      materialReportFileCheck: {}, //厂家材质报告校验
      qualificationFileCheck: {}, //合格证书校验
      addType1: false,
      look1Type: false,
      look2Type: false,
      look11Type: false,
      look21Type: false,
      look11ModifyType: false,
      data11Info: { sizeValue: "", inspectorId: "" }, //修改的信息
      table11Modify: [], //修改原物料list
      table2: [],
      table3: [],
      engineeringIdList: [],
      arr3_3: [],
      arr3_4: [],
      arr3_5: [],
      tableParam3: {
        //配合比-历史配合比列表分页
        page: 1,
        pageSize: 5,
        total: 0,
        engineeringId: "",
        dataType: this.status,
      },
      inspectorIdList: [],
      inspectorList: [],
      tableParam11: { page: 1, pageSize: 99999, total: 0 }, //产品分页1
      tableParam12: { page: 1, pageSize: 5, total: 0 }, //产品分页2
      tableParam13: { page: 1, pageSize: 5, total: 0 }, //产品分页3
      tableParam21: { page: 1, pageSize: 5, total: 0 }, //配合比分页1
      tableParam22: { page: 1, pageSize: 5, total: 0 }, //配合比分页2
      tableParam23: { page: 1, pageSize: 5, total: 0 }, //配合比分页3
      table11: [],
      table12: [],
      table13: [],
      table21: [],
      table22: [],
      table23: [],
      fromDate: { enginnerrMixRatio: "", cementBrandId: "", openingProjecName: "", structuralParts: "", strengthGrade: "", roadwork: "", calculateRatioMethod: 0,type:1 },
      yiFenPeiRadio: "",
      toViewList: [],
      plan: {}, //strengthGradeId是强度等级id,engineeringId是工程id
      table21ModifyName: "", //修改原物料供应商名称
      selectionChange11List: [], //自检报告库多选选中的
      selectionChange21radio: "", //自检报告库单选选中的
      rawIdArry: [], //获取基础配置的原物料列表
      specificationIdArry: [], //规格型号
      formulaParametersIdArry: [
        {
          id: "1",
          name: "水",
        },
        {
          id: "2",
          name: "水泥",
          type: true,
        },
        {
          id: "3",
          name: "细骨料",
        },
        {
          id: "4",
          name: "掺合料",
        },
        {
          id: "5",
          name: "外加剂",
        },
        {
          id: "6",
          name: "纤维",
        },
        {
          id: "7",
          name: "粗骨料",
        },
      ],
      list0Row: {},
      list0RowIndex: "",
      name: "", //出场、第三方
      name2: "", //批次检验、第三方检验
      nameName: "", //产品名，配合比
      fromDate3: {}, //新增报告
      addType: true, //
      mixRatioNumberType: false, //未配置时可以改配合比编号
      checkoutTableParam: {
        time: [],
        rawNameId: "",
        stationId: "",
        specificationId: "",
        supplierName: "",
        createTime: "",
        updateTime: "",
        brand: "",
        page: 1,
        pageSize: 10,
        total: 0,
      },
      checkoutData: [],
      checkoutDig: false,
      ListChoiceRadio: "",
      ListChoiceRadioRow: "",
      stationList: [],
      openingProjecList: [],
      modifyType: false,
      reportDig: false,
      toViewListLoad: false,
    };
  },
  async created() {
    /*获取基础配置的原物料列表*/
    getDicType({ code: "MATname" }).then(res => {
      this.rawIdArry = res.data.items.map(v => {
        return {
          id: v.id,
          name: v.itemName,
        };
      });
    });
    //站点
    getUserAutList(true).then(res => {
      this.stationList = res;
    });
    /**规格型号 */
    getDicType({ code: "MATspec" }).then(res => {
      this.specificationIdArry = res.data.items;
    });
    /**原物料品牌 */
    getDicType({
      code: "MATbrand",
    }).then(res => {
      this.arr3_3 = res.data.items;
    });
    /*工程列表下拉*/
    queryEngineeringList().then(res => {
      this.engineeringIdList = res.data;
    });
    //厂家材质报告
    getFileDetails({ code: "certificateOfApproval" }).then(res => {
      if (res.code === 1001) {
        console.log(res.data, "certificateOfApproval");
        this.materialReportFileCheck = res.data;
      }
    });
    //合格证书
    getFileDetails({ code: "manufacturerMaterialReport" }).then(res => {
      if (res.code === 1001) {
        console.log(res.data, "manufacturerMaterialReport");
        this.qualificationFileCheck = res.data;
      }
    });
    //this.treeData = await permissionsCompanyList();
    this.treeData = await orgUserTree("", 1);
    console.log(this.treeData);
    //检测人
    getUserInfoList().then(res => {
      this.userList = res.data;
    });
  },
  methods: {
    customizedReport() {
      this.reportDig = true;
      console.log(this.reportDig);
    },
    //单选选中
    ListChoiceFun(currentRow) {
      if (currentRow) {
        this.ListChoiceRadio = currentRow.id;
        this.ListChoiceRadioRow = currentRow;
        //选中后事件
      }
    },
    ListChoiceAddFun() {
      let json = {
        organizationId: this.plan.organizationId,
        stationName: this.ListChoiceRadioRow.station,
        stationId: this.ListChoiceRadioRow.stationId,
        companyId: this.plan.companyId,
        company: this.plan.company,
        supplierName: this.ListChoiceRadioRow.supplierName,
        rawName: this.ListChoiceRadioRow.rawName,
        brand: this.ListChoiceRadioRow.brand,
        dataSourcesId: this.ListChoiceRadioRow.id,
        specification: this.ListChoiceRadioRow.specification,
        type: 1,
        inspector: this.ListChoiceRadioRow.detection,
        inspectorId: this.ListChoiceRadioRow.inspectorId,
        samplingDate: this.ListChoiceRadioRow.detectionTime,
        rawId: this.ListChoiceRadioRow.rawNameId,
        checkoutNumber: this.ListChoiceRadioRow.code,
        rawMaterialsId: this.ListChoiceRadioRow.rawId,
      };
      if (this.name2 == "批次检验") {
        json.checkoutType = 3;
      } else if (this.name2 == "第三方检验") {
        json.checkoutType = 4;
      }
      saveResport(json).then(res => {
        if (res.code == 1001) {
          if (!res.data) {
            this.$confirm("已存在该编号报告是否继续?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              cancelButtonClass: "bottom_all_two",
              confirmButtonClass: "bottom_all",
              type: "warning",
            })
              .then(() => {
                saveOneRaw(json).then(res => {
                  if (res.code == 1001) {
                    this.getmaintenancelist21();
                    this.checkoutDig = false;
                  }
                });
              })
              .catch(() => {});
          } else {
            this.getmaintenancelist21();
            this.checkoutDig = false;
          }
        }
      });
    },

    openBatchcheckout() {
      this.checkoutDig = true;
      this.ListChoiceRadio = "";
      this.ListChoiceRadioRow = "";
      this.searchCheckout();
    },
    //批次检验数据
    searchCheckout() {
      if (this.checkoutTableParam?.time?.length) {
        this.checkoutTableParam.createTime = this.checkoutTableParam.time[0];
        this.checkoutTableParam.updateTime = this.checkoutTableParam.time[1];
      } else {
        this.checkoutTableParam.createTime = "";
        this.checkoutTableParam.updateTime = "";
      }
      checkoutQuerypage(this.checkoutTableParam).then(res => {
        if (res.code == 1001) {
          this.checkoutData = res.data.data;
          this.checkoutTableParam.total = res.data.totalRows;
          this.checkoutData.forEach(item => {
            item["disabled"] = false;
            this.table21.forEach(item2 => {
              if (item2.checkoutNumber == item.code) {
                item.disabled = true;
              }
            });
          });
        }
      });
    },
    /**上传前的验证 */
    beforeUpload(file) {
      console.log(this.scopeIndex, this.rowIndex);
      if (this.scopeIndex == 1) {
        if (!this.materialReportFileCheck || !this.materialReportFileCheck?.fileType) {
          this.$message.error("当前流程未配置附件，请配置后再进行上传");
          return false;
        }
        const fileType = file.name.split(".")[1];
        const isTYPE = this.materialReportFileCheck.fileType.indexOf(fileType) > -1;
        const isLtM = file.size / 1024 / 1024 < this.materialReportFileCheck.trillionSize;
        if (!isTYPE) {
          this.$message.error("图片格式只能为" + this.materialReportFileCheck.fileType);
          return false;
        }
        if (!isLtM) {
          this.$message.error(`图片大小不能超过${this.materialReportFileCheck.trillionSize}M`);
          return false;
        }
      } else if (this.scopeIndex == 2) {
        if (!this.qualificationFileCheck || !this.qualificationFileCheck?.fileType) {
          this.$message.error("当前流程未配置附件，请配置后再进行上传");
          return false;
        }
        const fileType = file.name.split(".")[1];
        const isTYPE = this.qualificationFileCheck.fileType.indexOf(fileType) > -1;
        const isLtM = file.size / 1024 / 1024 < this.qualificationFileCheck.trillionSize;
        if (!isTYPE) {
          this.$message.error("图片格式只能为" + this.qualificationFileCheck.fileType);
          return false;
        }
        if (!isLtM) {
          this.$message.error(`图片大小不能超过${this.qualificationFileCheck.trillionSize}M`);
          return false;
        }
      }
      loadingInstance = Loading.service({ text: "上传中..." });
      return true;
    },
    /**上传成功后的赋值 */
    filesuccess(res) {
      console.log(res.data);
      if (res.code === 1001) {
        if (this.scopeIndex == 1) {
          this.toViewList[this.rowIndex].materialReport = res.data.fileName;
          this.toViewList[this.rowIndex].materialReportPath = res.data.fileUrl;
          loadingInstance.close();
        } else if (this.scopeIndex == 2) {
          this.toViewList[this.rowIndex].qualification = res.data.fileName;
          this.toViewList[this.rowIndex].qualificationPath = res.data.fileUrl;
          loadingInstance.close();
        }
      }
    },
    /**自检报告-确定按钮 */
    addListlist0Fun() {
      if (this.selectionChange21radio != "") {
        let e = this.table21.find(res => res.id == this.selectionChange21radio) || this.table23.find(res => res.id == this.selectionChange21radio);
        if (this.name2 == "批次检验") {
          this.toViewList[this.list0RowIndex].selfBatchId = e.id;
          this.toViewList[this.list0RowIndex].selfBarchNum = e.checkoutNumber;
          this.toViewList[this.list0RowIndex].rawBrand = e.brand;
        } else if (this.name2 == "第三方检验") {
          this.toViewList[this.list0RowIndex].selfRipartiteId = e.id;
          this.toViewList[this.list0RowIndex].selfRipartiteNum = e.checkoutNumber;
          console.log(this.toViewList[this.list0RowIndex].selfRipartiteNum);
        }
        this.look21Type = false;
      }
    },
    /**分页获取原物料列表(批次、第三方*/
    look21Fun(e, name, index) {
      this.list0Row = e;
      this.list0RowIndex = index;
      this.checkoutTableParam.rawNameId = e.rawId;
      this.$data.tableParam21 = this.$options.data().tableParam21;
      this.$data.tableParam22 = this.$options.data().tableParam22;
      this.$data.tableParam23 = this.$options.data().tableParam23;
      if (this.list0Row.rawId != "" && this.list0Row.specification != "") {
        this.look21Type = true;
        this.name2 = name;
        this.nameName = "配合比";
        this.table21 = [];
        this.table22 = [];
        this.table23 = [];
        this.getmaintenancelist21(this.name2);
        // this.getmaintenancelist22(this.name2);
        this.getmaintenancelist23(this.name2);
      } else {
        this.$message({
          message: "请选择原物料及规格",
          type: "warning",
        });
      }
    },
    confirmCustomizedReport() {
      this.getmaintenancelist21();
    },
    /**查询配合比选择中的第一个表格 */
    getmaintenancelist21() {
      this.tableParam21.rawId = this.list0Row.rawId;
      // this.tableParam21.planId = this.plan.id;
      // this.tableParam21.strengthGradeId = this.plan.strengthGradeId;
      // this.tableParam21.stationId = this.plan.stationId;
      // this.tableParam21.companyId = this.plan.companyId;
      if (this.name2 == "批次检验") {
        this.tableParam21.checkoutTypes = "3,6";
      } else if (this.name2 == "第三方检验") {
        this.tableParam21.checkoutType = 4;
      }
      this.tableParam21.checkStatus = 1;
      queryPageRaw(this.tableParam21).then(res => {
        this.tableParam21.total = res.data.totalRows;
        this.table21 = res.data.data;
        /**选中的打钩 */
        // let selectArr = this.table21.filter(res => res.checkStatus == 1);
        // if (selectArr.length > 0) {
        //   this.selectionChange21radio = selectArr[0].id;
        // }
        this.selectionChange21radio = "";
      });
    },
    /**查询配合比选择中的第二个表格 */
    getmaintenancelist22() {
      this.tableParam22.rawId = this.list0Row.rawId;
      if (this.name2 == "批次检验") {
        this.tableParam22.dataTypeId = 2;
        this.tableParam22.dataStatus = 1;
        this.tableParam22.stationId = this.plan.stationId;
        this.tableParam22.specification = this.list0Row.specification;
        makequeryByRaw(this.tableParam22).then(res => {
          res.data.data.map(res => (res.checkoutNumber = res.code));
          this.table22 = res.data.data;
          this.tableParam22.total = res.data.totalRows;
        });
      } else if (this.name2 == "第三方检验") {
        this.tableParam22.companyId = this.plan.companyId;
        rawgetPageByRaw(this.tableParam22).then(res => {
          this.table22 = res.data.data;
          this.tableParam22.total = res.data.totalRows;
        });
      }
    },
    /**查询配合比选择中的第三个表格 */
    getmaintenancelist23() {
      this.tableParam23.rawId = this.list0Row.rawId;
      if (this.name2 == "批次检验") {
        this.tableParam23.checkoutTypes = "3,6";
        this.tableParam23.checkStatus = 2;
        queryPageRaw(this.tableParam23).then(res => {
          this.table23 = res.data.data;
          this.tableParam23.total = res.data.totalRows;
        });
      } else if (this.name2 == "第三方检验") {
        this.tableParam23.checkoutType = 4;
        selfreportqueryPage(this.tableParam23).then(res => {
          this.table23 = res.data.data;
          this.tableParam23.total = res.data.totalRows;
        });
      }
    },
    /**获取交工配合比详细配置 */
    workMixRatiogetRatioDetailFun() {
      workMixRatiogetRatioDetail({ id: this.fromDate.DetailId }).then(res => {
        console.log(res);
        this.fromDate = { ...this.fromDate, ...res.data, date: this.fromDate.date };
        this.toViewListLoad = true;
        this.toViewList = JSON.parse(JSON.stringify(this.fromDate.list));
        //获取最新选择原物料对应的自检报告 并赋值给当前选中的配合比
        getNewDetaHistory().then(res => {
          if (res.code == 1001) {
            this.toViewList.forEach((item, index) => {
              res.data.forEach(item2 => {
                if (item.rawId == item2.rawId && item.specificationId == item2.specificationId) {
                  this.$set(this.toViewList[index], "selfBatchId", item2.selfBatchId);
                  this.$set(this.toViewList[index], "selfBarchNum", item2.selfBarchNum);
                  this.$set(this.toViewList[index], "rawBrand", item2.rawBrand);
                }
              });
            });
          }
          this.toViewListLoad = false;
        });
      });
    },
    /** 返回交工配合比名称列表*/
    workMixRatioqueryListByGeneralFun() {
      this.arr3_5 = [];
      console.log(this.fromDate);
      let json = {
        companyId: this.plan.companyId,
        type: this.fromDate.type,
        name: this.fromDate.strengthGrade,
        id: this.plan.engineeringId,
        date: this.fromDate.date,
      };
      console.log(json);
      this.fromDate.DetailId = "";
      workMixRatioqueryListByGeneral(json).then(res => {
        this.arr3_5 = res.data;
      });
    },
    /**保存配合比 */
    discloseupdateOneFun() {
      var isfull = false;
      console.log(this.toViewList);
      this.toViewList.forEach(item => {
        if ((item.selfBarchNum == "" || item.selfBarchNum == null) && item.rawName != "水") {
          isfull = true; // 只要有一个selfBarchNum为空，就将isfull设置为false
        }
      });
      if (isfull == true) {
        this.$message({
          message: "请检查自检报告是否选择完毕",
          type: "warning",
        });
        return;
      }
      this.$refs.reffromDate.validate(valid => {
        if (valid) {
          if (this.toViewList.length == 0) {
            this.$message({
              message: "配合比参数列表不能为空！",
              type: "warning",
            });
            return;
          }
          if (this.fromDate.concreteRatioNumber.length != 9) {
            this.$message({
              message: "混凝土配合比编号必须为9位！",
              type: "warning",
            });
            return;
          }
          /**修改订单配合比特殊要求和水泥品牌 */
          let json = {
            id: this.plan.engineeringId, //工程id
            enginnerrMixRatio: this.fromDate.enginnerrMixRatio, //工程配合比特殊要求
            cementBrandId: this.fromDate.cementBrandId, // 水泥原物料品牌id
            openingProjecName: this.fromDate.openingProjecName,
            structuralParts: this.fromDate.structuralParts,
            roadwork: this.fromDate.roadwork,
            cementBrandName: this.fromDate.cementBrandName, //水泥原物料品牌
          };
          discloseupdateOne(json).then(res => {
            if (res.code == 1001) {
              this.fromDate.planId = this.plan.id;
              if (this.addType) {
                this.toViewList.map(res => {
                  res.type = 1;
                });
              } else {
                //toViewList数据对比开始
                let update = this.toViewList.filter(res => this.fromDate.list.some(item => res.id == item.id));
                update.forEach(res => {
                  res.type = 2; //修改的
                });
                let deleteData = this.fromDate.list.filter(res => !update.some(item => res.id == item.id));
                deleteData.forEach(res => {
                  res.type = 3; //3是删除
                });
                let addData = this.toViewList.filter(
                  //新增的type默认写死为 1
                  res => !update.some(item => res.id == item.id)
                );
                this.toViewList = [...update, ...deleteData, ...addData];
              }
              //toViewList数据对比结束
              this.fromDate.list = JSON.parse(JSON.stringify(this.toViewList));
              this.fromDate.engineeringId = this.plan.engineeringId;
              this.fromDate.dataType = this.status;
              console.log(this.fromDate);
              dataMixsaveOrUpdate(this.fromDate).then(res => {
                if (res.code == 1001) {
                  this.look2Type = false;
                  this.$message({
                    message: "操作成功",
                    type: "success",
                  });
                  this.$emit("reload");
                }
              });
              // let type = true
              // this.toViewList.forEach((v) => {
              //   //水泥砂石必选自检报告
              //   if ((v.formulaParametersId == 2 || v.formulaParametersId == 3 || v.formulaParametersId == 7)  && v.ratioValue != 0) {
              //     if (!v.selfBatchId || !v.specificationId) {
              //       type = false
              //     }
              //   }
              // })
              // if (type) {

              // } else {
              //   this.$message({
              //     message: '请检查数据是否完整',
              //     type: 'warning'
              //   });
              // }
            }
          });
        } else {
          return false;
        }
      });
    },
    //配合比中的已配置列表单选选中
    currentChange3(currentRow) {
      if (currentRow) {
        this.yiFenPeiRadio = currentRow.id;
        dataMixgetRatioDetail({ id: currentRow.id, dataType: this.status }).then(res => {
          if (res.data) {
            this.fromDate = { ...this.fromDate, ...res.data };
            this.toViewList = JSON.parse(JSON.stringify(this.fromDate.list));
          } else {
            this.$message({
              message: "该订单没有配合比参数",
              type: "warning",
            });
            setTimeout(() => {
              this.yiFenPeiRadio = "";
              this.$refs.singleTable.setCurrentRow();
            }, 2000);
          }
        });
      }
    },
    /**分页显示已分配配合比的订单列 */
    gettableData() {
      dataMixqueryPlan(this.tableParam3).then(res => {
        this.tableParam3.total = res.data.totalRows;
        this.table3 = res.data.data;
      });
    },
    /**点击配合比*/
    async look2Fun(e, type) {
      console.log(e, type);
      this.$data.fromDate = this.$options.data().fromDate;
      this.mixRatioNumberType = type;
      this.addType = true;
      this.plan = e;
      this.look2Type = true;
      this.toViewList = [];
      console.log(e.roadwork);
      this.fromDate.structuralParts = e.structuralParts;
      this.fromDate.productName = e.productName;
      this.fromDate.roadwork = e.roadwork;
      this.fromDate.date = moment().format("YYYY");
      console.log(this.fromDate);
      /*获取历史开盘工程数据 */
      await queryPlanEngineeringName({ engineeringId: e.engineeringId }).then(res => {
        if (res.data && res.code == 1001) {
          this.openingProjecList = res.data;
          if (res.data.length == 1) {
            this.fromDate.openingProjecName = res.data[0];
          }
        }
      });
      /**获取订单配合比特殊要求和水泥品牌 */
      await disclosequeryOne({ id: e.engineeringId, planId: this.plan.id }).then(res => {
        if (res.data) {
          console.log(res.data);
          this.fromDate.enginnerrMixRatio = res.data.enginnerrMixRatio;
          this.fromDate.cementBrandId = res.data.cementBrandId;
          this.fromDate.openingProjecName = res.data.openingProjecName || e.engineeringName;
          this.fromDate.roadwork = res.data.roadwork;
        }
      });
      this.tableParam3.engineeringId = e.engineeringId;
      this.gettableData();
      /**打开配置比显示默认数据 配合比开具时候的材料自检报告带出上一次开具的报告 */
      await this.dataMixgetByPlan(e)
    },
    async dataMixgetByPlan(e){
      await dataMixgetByPlan({ planId: e.id, engineeringId: e.engineeringId, dataType: this.status }).then(res => {
        if (res.data) {
          this.addType = false;
          var roadwork = this.fromDate.roadwork;
          this.fromDate = { ...this.fromDate, ...res.data };
          this.fromDate.roadwork = roadwork;
          // this.fromDate.concreteRatioNumber = res.data.concreteRatioNumber;
          this.fromDate.strengthGrade = e.strengthGrade;
          console.log(e);
          this.fromDate.calculateRatioMethod = this.fromDate.calculateRatioMethod || 0;
          this.toViewList = res.data.list;
          this.toViewList?.map(res => {
            res.type = 2;
          });
        } else {
          this.initFormData();
        }
        this.fromDate.mixRatioNumber = e.mixRatioNumber;
        this.workMixRatioqueryListByGeneralFun();
        console.log(e.mixRatioNumber);
        console.log(this.fromDate);
        // this.fromDate.concreteRatioNumber = e.concreteRatioNumber;
      });
    },
    /** 添加时初始列表 */
    initFormData() {
      this.toViewList = [];
      function data(a, b, c, d, e, f) {
        this.type = 1; //1新增，2修改，3删除
        this.rawName = f; //物料名称
        this.rawId = e; //物料id
        this.specification = ""; //规格
        this.specificationId = ""; //规格id
        this.ratioValue = 0; //配合比值
        this.list = [];
        this.formulaParameters = a; //公式参数类型
        this.formulaParametersId = b; //1水、2水泥、3细骨料、4掺合料、5外加剂、6纤维
        this.parametersType = c; //参数类型
        this.parameter = d; //参量
      }
      this.toViewList.push(new data("水", "1", "水", 100, "23219315838947328", "水"));
      this.toViewList.push(new data("水泥", "2", "水泥", 100, "14ece7eb4b1241b5a4218ddd23b69fd9", "水泥"));
      this.toViewList.push(new data("细骨料", "3", "细骨料", 100));
      this.toViewList.push(new data("外加剂", "5", "外加剂", 0));
    },
    /**修改页面——保存检验结果（三方和出场 */
    selfdetectionupdateManyFun() {
      // console.log(this.inspectorIdList.toString() )
      // console.log(this.inspectorList.toString() )
      // this.data11Info.inspectorId = this.inspectorIdList.join(',')
      // this.data11Info.inspector = this.inspectorList.join(' ')
      if (this.name == "出场" && !this.data11Info.sizeValue) {
        this.$message({
          message: "请选择构件尺寸",
          type: "warning",
        });
        return;
      }
      let type = true;
      this.table11Modify.forEach(v => {
        if (v.resultJudge == "NG") {
          type = false;
        }
      });
      if (type) {
        this.nameNameFun();
      } else {
        this.$confirm("是否保存", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          cancelButtonClass: "bottom_all_two",
          confirmButtonClass: "bottom_all",
          type: "warning",
        }).then(() => {
          this.nameNameFun();
        });
      }
      this.inspectorIdList = [];
      this.inspectorList = [];
    },
    /**修改页面——保存检验结果（三方和出场 */
    nameNameFun() {
      console.log(this.nameName);
      const params = {
        selfResport: {
          id: this.data11Info.id,
          supplierName: this.data11Info.supplierName,
          inspector: this.data11Info.inspector,
          inspectorId: this.data11Info.inspectorId,
          samplingDate: this.data11Info.samplingDate,
          checkoutNumber: this.data11Info.checkoutNumber,
          sizeId: this.data11Info.sizeValue === "100mm*100mm*100mm" ? 1 : 2,
          sizeValue: this.data11Info.sizeValue,
          originPlace: this.data11Info.originPlace,
          manufacturer: this.data11Info.manufacturer,
          dataOfProduction: this.data11Info.dataOfProduction,
          factoryNumber: this.data11Info.factoryNumber,
        },
        list: this.table11Modify,
      };
      selfdetectionupdateMany(params).then(res => {
        if (res.code == 1001) {
          this.look11ModifyType = false;
          this.$message.success("保存成功");
        }
      });
    },
    //多选选中
    selectionChange11(val) {
      this.selectionChange11List = val;
    },
    /**产品名-自检报告-保存 */
    planSelfsaveManyFun() {
      let arr = [];
      this.selectionChange11List.forEach(v => {
        arr.push({ selfReportId: v.id });
      });
      let json = {
        planId: this.plan.id,
        checkoutType: "", // 1出场检测 2三方检测,5抗渗报告
        list: arr,
        dataType: this.status, // 1交工配置 2 交工资料
      };
      if (this.name == "出场") {
        json.checkoutType = 1;
      } else if (this.name == "抗渗报告") {
        json.checkoutType = 5;
      } else if (this.name == "第三方") {
        json.checkoutType = 2;
      }
      // console.log(JSON.parse(JSON.stringify(json)))
      planSelfsaveMany(json).then(res => {
        if (res.code == 1001) {
          this.look11Type = false;
          this.$emit("reload");
        }
      });
    },
    /**新增报告 */
    selfreportsaveOneFun() {
      console.log(this.plan);
      //产品名和公用参数赋值
      this.fromDate3.strengthGradeId = this.plan.strengthGradeId;
      this.fromDate3.organizationId = this.plan.organizationId;
      this.fromDate3.stationName = this.plan.stationName;
      this.fromDate3.stationId = this.plan.stationId;
      this.fromDate3.companyId = this.plan.companyId;
      this.fromDate3.company = this.plan.company;
      this.fromDate3.productName = this.plan.productName;
      this.fromDate3.engineeringName = this.plan.engineeringName;
      this.fromDate3.engineeringId = this.plan.engineeringId;
      this.fromDate3.type = 2;
      if (this.name == "出场") {
        this.fromDate3.checkoutType = 1;
      } else if (this.name == "抗渗报告") {
        this.fromDate3.checkoutType = 5;
      }
      saveOneProduct(this.fromDate3).then(res => {
        if (res.code == 1001) {
          this.addType1 = false;
          this.getmaintenancelist11();
        }
      });
    },
    /**删除产品名的自检报告库 */
    delTable11Fun(e) {
      this.$confirm("此操作将删除本条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      }).then(() => {
        selfreportdelectMany({ id: e.id }).then(res => {
          if (res.code == 1001) {
            this.getmaintenancelist11(this.name);
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          }
        });
      });
    },
    /**删除配合比的自检报告库 */
    delTable21Fun(e) {
      this.$confirm("此操作将本条数据改为过期, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      }).then(() => {
        expireReport({ id: e.id }).then(res => {
          if (res.code == 1001) {
            this.getmaintenancelist21(this.name2);
            this.getmaintenancelist23(this.name2);
            // this.getmaintenancelist22(this.name2);
            this.$message({
              type: "success",
              message: "操作成功!",
            });
          }
        });
      });
    },
    /**自检报告库点开修改 */
    modifyLookFun(e, modifyType) {
      this.look11ModifyType = true;
      this.modifyType = modifyType;
      this.data11Info = e;
      this.inspectorName = e.inspector;
      this.table11Modify = [];
      selfdetectionqueryByReportId({ selfReportId: e.id }).then(res => {
        this.table11Modify = res.data.list;
        this.data11Info.sizeValue = res.data.selfResport.sizeValue;
        this.data11Info.samplingDate = res.data.selfResport.samplingDate;
        if (res.data.selfResport.inspectorId) {
          this.data11Info.inspectorId0 = res.data.selfResport.inspectorId.split(",") || [];
          this.data11Info.inspectorId = res.data.selfResport.inspectorId;
          this.data11Info.inspector = res.data.selfResport.inspector;
        } else {
          this.data11Info.inspectorId0 = [];
          this.data11Info.inspectorId = "";
          this.data11Info.inspector = "";
        }
        console.log(this.data11Info.inspectorId0);
      });
    },
    /*配合比-添加入库/复制到库（三方和出场）*/
    addtable21(e, name) {
      console.log(e);
      if (name == "原物料") {
        let json = {
          organizationId: this.plan.organizationId,
          stationName: this.plan.stationName,
          stationId: this.plan.stationId,
          companyId: this.plan.companyId,
          company: this.plan.company,
          supplierName: e.supplierName,
          rawName: e.rawName,
          brand: e.brand,
          dataSourcesId: e.id,
          specification: e.specification,
          type: 1,
          inspector: e.detection,
          inspectorId: e.inspectorId,
          samplingDate: e.detectionTime,
        };
        if (this.name2 == "批次检验") {
          json.checkoutType = 3;
          json.rawId = e.rawNameId;
          json.checkoutNumber = e.checkoutNumber;
          json.rawMaterialsId = e.rawId;
        } else if (this.name2 == "第三方检验") {
          json.checkoutType = 4;
          json.rawId = e.rawId;
          json.checkoutNumber = e.code;
        }
        saveOneRaw(json).then(res => {
          if (res.code == 1001) {
            this.getmaintenancelist21();
            // this.getmaintenancelist22(this.name2);
            this.getmaintenancelist23(this.name2);
          }
        });
      } else if (name == "已过期") {
        saveNewByCopy({ id: e.id }).then(res => {
          if (res.code == 1001) {
            this.getmaintenancelist21();
            // this.getmaintenancelist22();
            this.getmaintenancelist23();
          }
        });
      }
    },
    /**产品名-分页获取混凝土列表(三方和出场)*/
    look11Fun(e, name) {
      this.$data.tableParam11 = this.$options.data().tableParam11;
      this.$data.tableParam12 = this.$options.data().tableParam12;
      this.$data.tableParam13 = this.$options.data().tableParam13;
      this.name = name;
      this.nameName = "产品名";
      this.look11Type = true;
      this.plan = e;
      this.table11 = [];
      this.table12 = [];
      this.table13 = [];
      if (this.name == "出场" || this.name == "抗渗报告") {
        this.getmaintenancelist11(this.name);
      } else {
        this.getmaintenancelist11(this.name);
      }
    },
    /*产品名-分页获取自检报告（三方和出场*/
    getmaintenancelist11() {
      this.tableParam11.status = this.status; // 数据类型 1交工配置 2 交工资料
      this.tableParam11.planId = this.plan.id;
      this.tableParam11.strengthGradeId = this.plan.strengthGradeId;
      if (this.name == "出场") {
        this.tableParam11.stationId = this.plan.stationId;
        this.tableParam11.engineeringId = this.plan.engineeringId;
        this.tableParam11.checkoutType = 1;
      } else if (this.name == "抗渗报告") {
        this.tableParam11.stationId = this.plan.stationId;
        this.tableParam11.engineeringId = this.plan.engineeringId;
        this.tableParam11.checkoutType = 5;
      } else if (this.name == "第三方") {
        this.tableParam11.companyId = this.plan.companyId;
        this.tableParam11.checkoutType = 2;
      }
      selfreportqueryChecked(this.tableParam11).then(res => {
        this.tableParam11.total = res.data.totalRows;
        this.table11 = res.data.data;
        /**选中的打钩 */
        let selectArr = this.table11.filter(res => res.checkStatus == 1);
        selectArr.forEach(v => {
          this.$nextTick(() => {
            this.$refs.table11Refs.toggleRowSelection(v);
          });
          let type = this.selectionChange11List.findIndex(v2 => {
            return v.id == v2.id;
          });
          if (type == -1) {
            this.selectionChange11List.push(v);
          }
        });
      });
    },
    //单选选中
    selectionChange21radioFun(currentRow) {
      if (currentRow) {
        this.selectionChange21radio = currentRow.id;
      }
    },
    /**点击产品名 */
    look1Fun(e) {
      this.look1Type = true;
      this.table2 = [e];
    },
    /**验证OK还是NG */
    checkOkNgFun(val, technicalRequirements, section, row) {
      console.log(val, technicalRequirements, section);
      if (technicalRequirements == "≥") {
        if (Number(val) >= Number(section)) {
          row.resultJudge = "OK";
          return "OK";
        } else {
          row.resultJudge = "NG";
          return "NG";
        }
      } else if (technicalRequirements == "＞") {
        if (Number(val) > Number(section)) {
          row.resultJudge = "OK";
          return "OK";
        } else {
          row.resultJudge = "NG";
          return "NG";
        }
      } else if (technicalRequirements == "≤") {
        if (Number(val) <= Number(section)) {
          row.resultJudge = "OK";
          return "OK";
        } else {
          row.resultJudge = "NG";
          return "NG";
        }
      } else if (technicalRequirements == "＜") {
        if (Number(val) < Number(section)) {
          row.resultJudge = "OK";
          return "OK";
        } else {
          row.resultJudge = "NG";
          return "NG";
        }
      } else if (technicalRequirements == "=") {
        if (Number(val) == Number(section)) {
          row.resultJudge = "OK";
          return "OK";
        } else {
          row.resultJudge = "NG";
          return "NG";
        }
      } else if (technicalRequirements == "≤x,且x≤") {
        if (Number(val) >= Number(row.section.split(",")[0]) && Number(val) <= Number(row.section.split(",")[1])) {
          row.resultJudge = "OK";
          return "OK";
        } else {
          row.resultJudge = "NG";
          return "NG";
        }
      } else if (technicalRequirements == "<x,且x<") {
        if (Number(val) > Number(row.section.split(",")[0]) && Number(val) < Number(row.section.split(",")[1])) {
          row.resultJudge = "OK";
          return "OK";
        } else {
          row.resultJudge = "NG";
          return "NG";
        }
      } else if (technicalRequirements == "≤x,且x<") {
        if (Number(val) >= Number(row.section.split(",")[0]) && Number(val) < Number(row.section.split(",")[1])) {
          row.resultJudge = "OK";
          return "OK";
        } else {
          row.resultJudge = "NG";
          return "NG";
        }
      } else if (technicalRequirements == "<x,且x≤") {
        if (Number(val) > Number(row.section.split(",")[0]) && Number(val) <= Number(row.section.split(",")[1])) {
          row.resultJudge = "OK";
          return "OK";
        } else {
          row.resultJudge = "NG";
          return "NG";
        }
      } else if (technicalRequirements == "x≤,或x≥") {
        if (Number(val) <= Number(row.section.split(",")[0]) || Number(val) >= Number(row.section.split(",")[1])) {
          console.log("OK");
          row.resultJudge = "OK";
          return "OK";
        } else {
          console.log("NG");
          row.resultJudge = "NG";
          return "NG";
        }
      } else if (technicalRequirements == "x<或x>") {
        if (Number(val) < Number(row.section.split(",")[0]) || Number(val) > Number(row.section.split(",")[1])) {
          row.resultJudge = "OK";
          return "OK";
        } else {
          row.resultJudge = "NG";
          return "NG";
        }
      } else if (technicalRequirements == "≤x,或x<") {
        if (Number(val) >= Number(row.section.split(",")[0]) || Number(val) < Number(row.section.split(",")[1])) {
          row.resultJudge = "OK";
          return "OK";
        } else {
          row.resultJudge = "NG";
          return "NG";
        }
      } else if (technicalRequirements == "<x,或x≤") {
        if (Number(val) > Number(row.section.split(",")[0]) || Number(val) <= Number(row.section.split(",")[1])) {
          row.resultJudge = "OK";
          return "OK";
        } else {
          row.resultJudge = "NG";
          return "NG";
        }
      }
    },
    /**前4个不能操作的改色--------下面都是配合比中的表格 */
    tableRowClassName({ rowIndex }) {
      if (rowIndex < 4) {
        return "ccc";
      }
    },
    /**赋值name名 */
    changeItem(e, name) {
      if (name == "rawId") {
        e.rawName = this.$fromatTable(this.rawIdArry, e.rawId, "id", "name");
        this.calculatorFun();
      } else if (name == "specificationId") {
        e.specification = this.$fromatTable(this.specificationIdArry, e.specificationId, "id", "itemName");
      } else if (name == "formulaParametersId") {
        e.formulaParameters = this.$fromatTable(this.formulaParametersIdArry, e.formulaParametersId, "id", "name");
        this.parametersTypeFun();
        this.calculatorFun();
      }
    },
    /*表单增加*/
    addItem() {
      let data = {
        type: 1, //1新增，2修改，3删除
        rawName: "", //物料名称
        rawId: "", //物料id
        specification: "", //规格
        specificationId: "", //规格id
        formulaParameters: "", //公式参数类型
        formulaParametersId: "", //1水、2水泥、3细骨料、4掺合料、5外加剂、6纤维
        parametersType: "", //参数类型
        parameter: 0, //参量
        ratioValue: 0, //配合比值
        list: [],
      };
      this.toViewList.push(data);
    },
    // 清空
    deleAllItem(){
        clearPlanReport(this.toViewList).then(res => {
         if (res.code == 1001) {
           this.dataMixgetByPlan(this.plan)
         }else{
           this.$message({
             message: res.message,
             type: "error",
           });
          }
      });
    },
    /*表单删除*/
    deleteItem(index) {
      this.toViewList.splice(index, 1);
      this.parametersTypeFun();
      this.calculatorFun();
    },
    /** 算值配合比值,同时验证参数是否完整 */
    calculatorFun(type) {
      if (!this.fromDate.unitWeight || !this.fromDate.totalPlasticMaterial || !this.fromDate.waterBinderRatio || !this.fromDate.sandRatio) {
        if (!type) {
          this.$message({
            message: "请填写容重、胶材总量、水胶比、砂率",
            type: "warning",
          });
        }
        // if (index > 2) {
        //   setTimeout(() => {
        //     e.parameter = 0
        //   }, 10)
        // } else {
        //   setTimeout(() => {
        //     e.parameter = 100
        //   }, 10)
        // }
      } else {
        //手动输入不计算 自动输入计算
        if (this.fromDate.calculateRatioMethod == 0) {
          /** 所有水的配合比值和 */
          let waterAll = 0;
          /** 所有水泥的配合比值和 */
          let cementAll = 0;
          /** 所有掺合料的配合比值和 */
          let admixtureAll = 0;
          /** 所有掺合料的参量和 */
          let admixtureParameterAll = 0;
          /** 所有外加剂的配合比值和 */
          let additiveAll = 0;
          /** 所有细骨料的配合比值和 */
          let slenderAll = 0;
          /*所有纤维的参量和 */
          let fibreAll = 0;
          //判断是否含有钢纤维或者玄武岩纤维
          let isFibre = false;
          //按调用参数顺序先算4，5，再算1，再算2，再算3，再算7【6跟谁都无关最后算】!!!!!!!!!!!!!!!
          //4掺合量和5:外加剂：胶材总量*参量
          this.toViewList.forEach(v => {
            if (v.formulaParametersId == 4 || v.formulaParametersId == 5) {
              if (v.formulaParametersId == 5) {
                v.ratioValue = (Number(this.fromDate.totalPlasticMaterial) * (v.parameter / 100)).toFixed(2);
              } else {
                v.ratioValue = (Number(this.fromDate.totalPlasticMaterial) * (v.parameter / 100)).toFixed(0);
              }
            }
          });
          this.toViewList.forEach(v => {
            if (v.formulaParametersId == 4) {
              admixtureAll = admixtureAll + Number(v.ratioValue);
              admixtureParameterAll = admixtureParameterAll + Number(v.parameter / 100);
            }
            if (v.formulaParametersId == 5) {
              additiveAll = additiveAll + Number(v.ratioValue);
            }
          });
          //1水：胶材总量*水胶比-（所有外加剂的配合比值和 *0.9）*水N的参量
          // this.toViewList.forEach((v) => {
          //   if (v.formulaParametersId == 1) {
          //     v.ratioValue = ((Number(this.fromDate.totalPlasticMaterial) * Number(this.fromDate.waterBinderRatio)) - (additiveAll * 0.9) * (v.parameter / 100)).toFixed(0)
          //   }
          // })
          // 修改为 水N配合比值=胶材总量*水胶比
          this.toViewList.forEach(v => {
            if (v.formulaParametersId == 1) {
              v.ratioValue = (Number(this.fromDate.totalPlasticMaterial) * Number(this.fromDate.waterBinderRatio)).toFixed(0);
            }
          });
          this.toViewList.forEach(v => {
            if (v.formulaParametersId == 1) {
              waterAll = waterAll + Number(v.ratioValue);
            }
          });
          //2水泥：胶材总量*（1-所有掺合料参量的和）
          this.toViewList.forEach(v => {
            if (v.formulaParametersId == 2) {
              v.ratioValue = (Number(this.fromDate.totalPlasticMaterial) * (1 - admixtureParameterAll)).toFixed(0);
            }
          });
          this.toViewList.forEach(v => {
            if (v.formulaParametersId == 2) {
              cementAll = cementAll + Number(v.ratioValue);
            }
          });
          //6纤维：配合比值同参量值
          this.toViewList.forEach(v => {
            if (v.formulaParametersId == 6) {
              v.ratioValue = v.parameter;
            }
          });
          this.toViewList.forEach(v => {
            if (v.formulaParametersId == 6) {
              fibreAll = fibreAll + Number(v.ratioValue);
            }
            if (v.rawId == "101457636649734144" || v.rawId == "210505982248357888") {
              isFibre = true;
            }
          });
          //3确认细骨料N：【容重-所有水的配合比值之和-所有水泥配合比值之和-所有掺合料的配合比值之和-所有外加剂的配合比值之和】*砂率
          //变动内容 [去掉参量 *细骨料N的参量 * (v.parameter / 100)]
          this.toViewList.forEach(v => {
            if (v.formulaParametersId == 3) {
              if (isFibre) {
                v.ratioValue = ((Number(this.fromDate.unitWeight) - waterAll - cementAll - admixtureAll - additiveAll - fibreAll) * (Number(this.fromDate.sandRatio) / 100)).toFixed(0);
              } else {
                v.ratioValue = ((Number(this.fromDate.unitWeight) - waterAll - cementAll - admixtureAll - additiveAll) * (Number(this.fromDate.sandRatio) / 100)).toFixed(0);
              }
            }
          });
          this.toViewList.forEach(v => {
            if (v.formulaParametersId == 3) {
              slenderAll = slenderAll + Number(v.ratioValue);
            }
          });
          //7确认粗骨料N：【容重-所有水的配合比值之和-所有水泥配合比值之和-所有掺合料的配合比值之和-所有外加剂的配合比值之和】*(1-砂率)
          //原内容 7粗骨料N：[（所有细骨料的配合比值之和/砂率）-所有细骨料的配合比值之和]*粗骨料N参量
          this.toViewList.forEach(v => {
            if (v.formulaParametersId == 7) {
              if (isFibre) {
                v.ratioValue = ((Number(this.fromDate.unitWeight) - waterAll - cementAll - admixtureAll - additiveAll - fibreAll) * (1 - Number(this.fromDate.sandRatio) / 100)).toFixed(0);
              } else {
                v.ratioValue = ((Number(this.fromDate.unitWeight) - waterAll - cementAll - admixtureAll - additiveAll) * (1 - Number(this.fromDate.sandRatio) / 100)).toFixed(0);
              }
              //  v.ratioValue = ((slenderAll / (Number(this.fromDate.sandRatio) / 100) - slenderAll) * (v.parameter / 100)).toFixed(0)
            }
          });
        }
      }
    },
    /** 参数类型多个时追加拼接数字 */
    parametersTypeFun() {
      /** 公式参数类型：水的数量 */
      let waterSize = 0;
      /** 公式参数类型：细骨料的数量 */
      let slenderSize = 0;
      /** 公式参数类型：掺合料的数量 */
      let admixtureSize = 0;
      /** 公式参数类型：外加剂的数量 */
      let additive = 0;
      /** 公式参数类型：纤维的数量 */
      let fiberSize = 0;
      /** 公式参数类型：粗骨料的数量 */
      let thickSize = 0;
      this.toViewList.forEach(v => {
        if (v.formulaParametersId == 1) {
          waterSize = waterSize + 1;
        } else if (v.formulaParametersId == 3) {
          slenderSize = slenderSize + 1;
        } else if (v.formulaParametersId == 4) {
          admixtureSize = admixtureSize + 1;
        } else if (v.formulaParametersId == 5) {
          additive = additive + 1;
        } else if (v.formulaParametersId == 6) {
          fiberSize = fiberSize + 1;
        } else if (v.formulaParametersId == 7) {
          thickSize = thickSize + 1;
        }
      });
      /** 拼接的数字 */
      let sizeText1 = 0,
        sizeText3 = 0,
        sizeText4 = 0,
        sizeText5 = 0,
        sizeText6 = 0,
        sizeText7 = 0;
      this.toViewList.forEach(v => {
        if (v.formulaParametersId == 1) {
          if (waterSize > 1) {
            sizeText1 = sizeText1 + 1;
            v.parametersType = v.formulaParameters + String(sizeText1);
          } else {
            v.parametersType = v.formulaParameters;
          }
        } else if (v.formulaParametersId == 3) {
          if (slenderSize > 1) {
            sizeText3 = sizeText3 + 1;
            v.parametersType = v.formulaParameters + String(sizeText3);
          } else {
            v.parametersType = v.formulaParameters;
          }
        } else if (v.formulaParametersId == 4) {
          if (admixtureSize > 1) {
            sizeText4 = sizeText4 + 1;
            v.parametersType = v.formulaParameters + String(sizeText4);
          } else {
            v.parametersType = v.formulaParameters;
          }
        } else if (v.formulaParametersId == 5) {
          if (additive > 1) {
            sizeText5 = sizeText5 + 1;
            v.parametersType = v.formulaParameters + String(sizeText5);
          } else {
            v.parametersType = v.formulaParameters;
          }
        } else if (v.formulaParametersId == 6) {
          if (fiberSize > 1) {
            sizeText6 = sizeText6 + 1;
            v.parametersType = v.formulaParameters + String(sizeText6);
          } else {
            v.parametersType = v.formulaParameters;
          }
        } else if (v.formulaParametersId == 7) {
          if (thickSize > 1) {
            sizeText7 = sizeText7 + 1;
            v.parametersType = v.formulaParameters + String(sizeText7);
          } else {
            v.parametersType = v.formulaParameters;
          }
        }
      });
    },
    TreeSelectStypeFun() {
      if (this.TreeSelectStypeNumber === 0) {
        this.TreeSelectStypeNumber = 1;
        setTimeout(() => {
          const dom = document.body.lastChild;
          dom.style.zIndex = "10000";
        }, 1000);
      }
    },
    selectInspector() {
      this.$forceUpdate();
      this.$nextTick(() => {
        const ids = [];
        const names = [];
        console.log(this.data11Info.inspectorId0);
        console.log(this.$refs.inspectorId.selected);
        this.$refs.inspectorId.selected.forEach(item => {
          ids.push(item.value);
          let inspectorNow = this.userList.find(item2 => item2.id == item.value);
          names.push(inspectorNow.name);
        });
        this.$set(this.data11Info, "inspectorId0", ids);
        this.data11Info.inspectorId = ids.join(",");
        this.data11Info.inspector = names.join(" ");
      });
    },
    setLabel(item) {
      this.inspectorIdList.push(item.id);
      this.inspectorList.push(item.name);
    },
    onLoadData(treeNode) {
      return new Promise(resolve => {
        if (treeNode.dataRef.children) {
          // 有值了直接渲染
          resolve();
          return;
        }
        /**获取自己公司加权限组织树带人员的 */
        // 没有值根据当前父节点获取下面子节点并挂在树节点中，添加到对应父节点的children中
        getOrgznizationAndUsersTree(treeNode.dataRef.id).then(res => {
          let children = res.data[0].children;
          this.diGui(children);
          treeNode.dataRef.children = children;
          this.$forceUpdate();
          console.log(JSON.parse(JSON.stringify(this.treeData)));
        });
        resolve();
      });
    },
    //递归判断是否是子节点
    diGui(arr) {
      if (arr.length > 0) {
        arr.forEach(res => {
          if (res.children > 0) {
            this.diGui(res.children);
          } else {
            delete res.children;
            if (res.selectable == true) {
              res.isLeaf = true;
            }
          }
        });
      }
    },
  },
  filters: {
    filtFormula(index) {
      if (index > 3) {
        return false;
      } else {
        return true;
      }
    },
    precision(e) {
      if (e.formulaParametersId == 4) {
        return 1;
      } else if (e.formulaParametersId == 5 || e.formulaParametersId == 6) {
        return 2;
      } else {
        return 0;
      }
    },
    filtDel(index) {
      if (index > 3) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.table_link {
  margin: 0 10px;
  color: $bg_color;
  cursor: pointer;
}

.table_link:hover {
  opacity: 0.8;
}
.el-link.el-link--default.is-disabled {
  cursor: not-allowed;
  display: flex;
}
</style>
